import { createSelector } from 'reselect';
import { keys } from '../../../constants/keys.esm.js';

function getDefaultCategory(resources) {
  return {
    label: resources.allFields(),
    id: keys.allFields
  };
}
var defaultCategorySelector = createSelector(function (props) {
  return props.resources;
}, getDefaultCategory);

export { defaultCategorySelector };
//# sourceMappingURL=default-category-selector.esm.js.map
